<template>
  <com-page>
    <com-search :columns="searchColumns" @search="handleSearch">
      <template>
        <el-button type="primary" @click="handleCreated">新增</el-button>
      </template>
    </com-search>
    <com-card>
      <com-table ref="table" :columns="columns" :api="api">
        <template #hasGive="row">
          <div>
            {{ hasGiveStatus[row.data.hasGive] }}
          </div>
        </template>
        <template #createdTime="row">
          <div>
            {{ row.data.createTime | formatDate }}
          </div>
        </template>
        <template #operation="row">
          <el-button type="primary" @click="handleEdit(row.data)" class="mb-5px" size="mini"
            >编辑</el-button
          >
          <el-button v-if="row.data.code !== '6f3483a57ddb482799d5b25aa0a66681'" type="danger" @click="handleDel(row.data)" class="mb-5px" size="mini"
            >删除</el-button
          >
        </template>
      </com-table>
    </com-card>
    <the-add-recharge-package ref="rechargePackage" @success="handleUpdate"></the-add-recharge-package>
  </com-page>
</template>

<script>
import { list, deleteApi } from '@/api/recharge-package'

import theAddRechargePackage from './components/the-add-recharge-package'

export default {
  components: { theAddRechargePackage },
  data() {
    return {
      api: list,
      hasGiveStatus: {
        1: '是',
        0: '否'
      },
      searchColumns: [
        {
          label: '套餐名称',
          type: 'input',
          prop: 'name'
        },
      ],
      columns: [
        {
          label: '编号',
          prop: 'number',
          minWidth: 150
        },
        {
          label: '套餐名称',
          prop: 'name',
          minWidth: 150
        },
        {
          label: '关联小区数',
          prop: 'storeNums'
        },
        {
          label: '是否有赠送',
          type: 'slot',
          prop: 'hasGive',
          slotName: 'hasGive'
        },
        {
          label: '创建人',
          prop: 'refCreateUserName',
        },
        {
          label: '创建时间',
          type: 'slot',
          prop: 'createdTime',
          slotName: 'createdTime'
        },
        {
          label: '操作',
          prop: 'operation',
          type: 'slot',
          slotName: 'operation',
          width: 250,
          fixed: 'right'
        }
      ]
    }
  },
  methods: {
    handleCreated() {
      const params = {
        type: 'created'
      }
      this.$refs.rechargePackage.open(params)
    },
    handleUpdate() {
      this.$refs.table.init()
    },
    handleEdit(row) {
      const params = {
        type: 'edit',
        code: row.code
      }
      this.$refs.rechargePackage.open(params)
    },
    handleDel(row) {
      this.$confirm('此操作将删除该套餐, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const params = {
            code: row.code
          }
          deleteApi(params).then((res) => {
            const { desc } = res
            this.$message.success(desc)
            this.handleUpdate()
          })
        })
        .catch(() => {})
    },
    handleSearch(opt) {
      if (opt.beginTime) {
        opt.startTime = opt.beginTime
      }
      delete opt.beginTime
      this.$refs.table.search(opt)
      console.log('opt :>> ', opt)
    },
  }
}
</script>

<style lang="scss" scoped></style>
